import axios from 'axios';
import {Translation} from '../Model/TranslationOutput';

const TranslationService = async (url: string) => {

  try {
    const { data } = await axios.get<Translation>(url,
      {
        headers: {
          Accept: 'application/json',
        },
        timeout:20000,
      },
    );
    return data;
  }
  catch (error)
  {
    if (axios.isAxiosError(error))
    {
      return error.message;
    }
    else
    {
      return 'An unexpected error occurred';
    }
  }
}

export default TranslationService;